import { css } from 'goober';
import React from 'react';
const Bubble = (size, type, color = '#fee78a') => css `
  position: absolute;
  height: ${size}px;
  width: ${size}px;
  background: ${color};
  border-radius: 50%;
  ${type === 'top' ? 'top: -5px; left: 0;' : ''}
  ${type === 'rightbottom' ? 'bottom: 5px; right: 0px;' : ''}
  ${type === 'leftbottom' ? 'bottom: 2px; left: 5px;' : ''}
`;
const IconBubbles = (props) => {
    const { color } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: Bubble(10, 'top', color) }),
        React.createElement("div", { className: Bubble(6, 'rightbottom', color) }),
        React.createElement("div", { className: Bubble(4, 'leftbottom', color) })));
};
export default IconBubbles;
//# sourceMappingURL=index.js.map